import {
  Button,
  Col,
  Form,
  InputNumber,
  Modal,
  Row,
  Space,
  Typography,
} from "antd";
import axios from "axios";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { NotificationInfo, PermissionInfo, UserInfo } from "../../context";
import moment from "moment";
import _ from "lodash";

const DialogCashCount = ({ open, close, rerun, selectedData }) => {
  const [oneThousandBill, setoneThousandBill] = useState(0);
  const [fiveHundredBill, setfiveHundredBill] = useState(0);
  const [twoHundredBill, settwoHundredBill] = useState(0);
  const [oneHundredBill, setoneHundredBill] = useState(0);
  const [fiftyBill, setfiftyBill] = useState(0);
  const [twentyBill, settwentyBill] = useState(0);
  const [twentyCoin, settwentyCoin] = useState(0);
  const [tenCoin, settenCoin] = useState(0);
  const [fiveCoin, setfiveCoin] = useState(0);
  const [oneCoin, setoneCoin] = useState(0);
  const [fiftyCentsCoin, setfiftyCentsCoin] = useState(0);
  const [twentyfiveCentsCoin, settwentyfiveCentsCoin] = useState(0);
  const [tenCentsCoin, settenCentsCoin] = useState(0);
  const [fiveCentsCoin, setfiveCentsCoin] = useState(0);
  const [oneCentCoin, setoneCentCoin] = useState(0);
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const { permissionList } = useContext(PermissionInfo);
  const date_now = moment(`${moment().format("YYYY-MM-DDTHH:mm:ss.000000Z")}`)
    // .utc()
    .format("YYYY-MM-DD");
  const [totalSales, setTotalSales] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);

  const [totalCash, setTotalCash] = useState(0);
  const [totalNonCash, setTotalNonCash] = useState(0);
  const [totalGcash, setTotalGcash] = useState(0);
  const [totalGcredit, setTotalGcredit] = useState(0);
  const [totalPaymaya, setTotalPaymaya] = useState(0);
  const [totalCreditcard, setTotalCreditcard] = useState(0);
  const [totalDebitcard, setTotalDebitcard] = useState(0);
  const [totalBankTransfer, setTotalBankTransfer] = useState(0);
  const [totalCheque, setTotalCheque] = useState(0);

  const time_now = moment(`${moment().format("YYYY-MM-DDTHH:mm:ss")}`).format(
    "HH:mm:ss"
  );

  const handleUpdatedADailyCashCount = (values) => {
    const formdata = new FormData();
    formdata.append("user", "cashier");
    formdata.append("user_id", userData.data.id);
    formdata.append(
      "merchant_user_id",
      userData.data.usersmerchantemployee.merchant_user_id
    );
    formdata.append("id", selectedData !== null && selectedData.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    formdata.append("daily_sales", totalSales);
    formdata.append("daily_expense", totalExpense);
    formdata.append(
      "g_total",
      parseFloat(oneThousandBill) +
        parseFloat(fiveHundredBill) +
        parseFloat(twoHundredBill) +
        parseFloat(oneHundredBill) +
        parseFloat(fiftyBill) +
        parseFloat(twentyBill) +
        parseFloat(twentyCoin) +
        parseFloat(tenCoin) +
        parseFloat(fiveCoin) +
        parseFloat(oneCoin) +
        parseFloat(fiftyCentsCoin) +
        parseFloat(twentyfiveCentsCoin) +
        parseFloat(tenCentsCoin) +
        parseFloat(fiveCentsCoin) +
        parseFloat(oneCentCoin)
    );

    formdata.append("cash", totalCash);
    formdata.append("ecash", totalNonCash);
    formdata.append("gcash", totalGcash);
    formdata.append("gcredit", totalGcredit);
    formdata.append("paymaya", totalPaymaya);
    formdata.append("creditcard", totalCreditcard);
    formdata.append("debitcard", totalDebitcard);
    formdata.append("banktransfer", totalBankTransfer);
    formdata.append("cheque", totalCheque);

    axios
      .post("user/merchant-employee/update/cash-count-daily", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated cash count successfully.");
          setTimeout(() => {
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const getDailySalesList = useCallback(() => {
    var date_from = "";
    var date_to = "";
    if (
      permissionList.data.merchant_info.operation_opens !== null &&
      permissionList.data.merchant_info.operation_closes !== null
    ) {
      if (
        permissionList.data.merchant_info.operation_closes <
        permissionList.data.merchant_info.operation_opens
      ) {
        // if (time_now > permissionList.data.merchant_info.operation_opens) {
        //   date_from = moment(
        //     `${date_now}T${permissionList.data.merchant_info.operation_opens}`
        //   ).format("YYYY-MM-DDTHH:mm:ss");
        //   date_to = moment(
        //     `${date_now}T${permissionList.data.merchant_info.operation_closes}`
        //   )
        //     .add(1, "day")
        //     .format("YYYY-MM-DDTHH:mm:ss");
        // } else {
        //   date_from = moment(
        //     `${date_now}T${permissionList.data.merchant_info.operation_opens}`
        //   )
        //     .subtract(1, "day")
        //     .format("YYYY-MM-DDTHH:mm:ss");
        //   date_to = moment(
        //     `${date_now}T${permissionList.data.merchant_info.operation_closes}`
        //   ).format("YYYY-MM-DDTHH:mm:ss");
        // }

        if (
          moment().format("HH:mm:ss") >=
          permissionList.data.merchant_info.operation_closes
        ) {
          // console.log("DIRI");
          date_from = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_opens}`
          ).format("YYYY-MM-DDTHH:mm:ss");
          date_to = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_closes}`
          )
            .add(1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
        } else {
          // console.log("DIRE");

          date_from = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_opens}`
          )
            .subtract(1, "days")
            .format("YYYY-MM-DDTHH:mm:ss");
          date_to = moment(
            `${date_now}T${permissionList.data.merchant_info.operation_closes}`
          ).format("YYYY-MM-DDTHH:mm:ss");
        }
      } else {
        date_from = moment(
          `${date_now}T${permissionList.data.merchant_info.operation_opens}`
        ).format("YYYY-MM-DDTHH:mm:ss");
        date_to = moment(
          `${date_now}T${permissionList.data.merchant_info.operation_closes}`
        ).format("YYYY-MM-DDTHH:mm:ss");
      }
    } else {
      date_from = moment(`${date_now}T00:00:00`).format("YYYY-MM-DDTHH:mm:ss");
      date_to = moment(`${date_now}T23:59:00`).format("YYYY-MM-DDTHH:mm:ss");
    }

    var params = {
      user_id: userData.data.id,
      // date_now: moment(`${new Date()}.000000Z`).utc().format("YYYY-MM-DD"),
      date_from,
      date_to,
    };
    axios
      .get("user/merchant-employee/get/daily-sales", { params })
      .then((response) => {
        setTotalSales(getTotalCost(response.data));

        //new
        const res = _.chain(response.data)
          .groupBy((g) => g.transaction_id)
          .map((value, key) => ({
            transaction_id: key,
            data: value,

            cash: getTotalCash(value),
            ecash: getTotalECash(value),
            gcash: getTotalNonCash("gcash", value),
            gcredit: getTotalNonCash("gcredit", value),
            paymaya: getTotalNonCash("paymaya", value),
            creditcard: getTotalNonCash("creditcard", value),
            debitcard: getTotalNonCash("debitcard", value),
            banktransfer: getTotalNonCash("banktransfer", value),
            cheque: getTotalNonCash("cheque", value),
          }))
          .value();

        setTotalCash(calculateAll("cash", res));
        setTotalNonCash(calculateAll("ecash", res));
        setTotalGcash(calculateAll("gcash", res));
        setTotalGcredit(calculateAll("gcredit", res));
        setTotalPaymaya(calculateAll("paymaya", res));
        setTotalCreditcard(calculateAll("creditcard", res));
        setTotalDebitcard(calculateAll("debitcard", res));
        setTotalBankTransfer(calculateAll("banktransfer", res));
        setTotalCheque(calculateAll("cheque", res));

        // console.log("RES: ", res);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const calculateAll = (category, data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (category === "cash") {
        total += parseFloat(data[i].cash) * 1;
      }
      if (category === "ecash") {
        total += parseFloat(data[i].ecash) * 1;
      }
      //new
      if (category === "gcash") {
        total += parseFloat(data[i].gcash) * 1;
      }
      if (category === "gcredit") {
        total += parseFloat(data[i].gcredit) * 1;
      }
      if (category === "paymaya") {
        total += parseFloat(data[i].paymaya) * 1;
      }
      if (category === "creditcard") {
        total += parseFloat(data[i].creditcard) * 1;
      }
      if (category === "debitcard") {
        total += parseFloat(data[i].debitcard) * 1;
      }
      if (category === "banktransfer") {
        total += parseFloat(data[i].banktransfer) * 1;
      }
      if (category === "cheque") {
        total += parseFloat(data[i].cheque) * 1;
      }
    }
    return total;
  };

  const getTotalNonCash = (category, data) => {
    var total = 0;
    if (data[0].noncash === category) {
      total = parseFloat(data[0].epayment);
    }
    return total;
  };

  const getTotalCash = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].payment_method === "cash") {
        total +=
          (parseInt(data[i].is_per_piece) === 1
            ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
              parseFloat(data[i].price)
            : parseFloat(data[i].price) * 1) +
          parseFloat(
            data[i].cost_per_prod !== null
              ? parseInt(data[i].is_per_piece) === 0
                ? data[i].cost_per_prod
                : data[i].cost_per_prod * data[i].quantity
              : 0
          ) -
          parseFloat(data[i].discount_amount);
      }
      if (data[i].payment_method === "split-cash") {
        total = parseFloat(data[0].payment);
      }
    }
    return total;
  };

  const getTotalECash = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      if (data[i].payment_method === "ecash") {
        total +=
          (parseInt(data[i].is_per_piece) === 1
            ? (data[i].quantity !== null ? parseInt(data[i].quantity) : 1) *
              parseFloat(data[i].price)
            : parseFloat(data[i].price) * 1) +
          parseFloat(
            data[i].cost_per_prod !== null
              ? parseInt(data[i].is_per_piece) === 0
                ? data[i].cost_per_prod
                : data[i].cost_per_prod * data[i].quantity
              : 0
          ) -
          parseFloat(data[i].discount_amount);
      }
      if (data[i].payment_method === "split-cash") {
        total = parseFloat(data[0].epayment);
      }
    }
    return total;
  };

  const getTotalCost = (data) => {
    var total = 0;
    // console.log("DATA: ", data);
    for (let i = 0; i < data.length; i++) {
      var initial =
        parseInt(data[i].is_per_piece) === 0
          ? parseFloat(data[i].price)
          : parseInt(data[i].quantity) * parseFloat(data[i].price);
      // console.log("INITIAL: ", initial);
      var secondary = parseFloat(
        parseInt(data[i].is_per_piece) === 0
          ? data[i].cost_per_prod
          : data[i].cost_per_prod * data[i].quantity
      );
      // console.log("SECONDARY: ", secondary);
      // console.log("FINAL: ", initial + secondary);

      total += initial + secondary;
    }
    return total;
  };

  const getExpenseSpecCashCount = useCallback(() => {
    var params = {
      cash_count_id: selectedData !== null && selectedData.id,
    };
    axios
      .get("user/merchant-employee/get/cash-count-expense", { params })
      .then((response) => {
        setTotalExpense(getTotalAmount(response.data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getTotalAmount = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseInt(data[i].amount) * 1;
    }
    return total;
  };

  useEffect(() => {
    getDailySalesList();
    getExpenseSpecCashCount();
  }, [getDailySalesList, getExpenseSpecCashCount]);

  // console.log("totalSales: ", totalSales);
  console.log("totalCash: ", totalCash);
  console.log("totalNonCash: ", totalNonCash);
  console.log("totalGcash: ", totalGcash);
  console.log("totalGcredit: ", totalGcredit);
  console.log("totalPaymaya: ", totalPaymaya);
  console.log("totalCreditcard: ", totalCreditcard);
  console.log("totalDebitcard: ", totalDebitcard);
  console.log("totalBankTransfer: ", totalBankTransfer);
  console.log("totalCheque: ", totalCheque);

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      //   closable={false}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="update-cash-count"
        onFinish={handleUpdatedADailyCashCount}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Row>
            <Col
              xs={24}
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                PESO BILL
              </Typography>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_1000"
                  label="1000 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneThousandBill(value * 1000)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_500"
                  label="500 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveHundredBill(value * 500)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_200"
                  label="200 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwoHundredBill(value * 200)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_100"
                  label="100 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneHundredBill(value * 100)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_50"
                  label="50 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiftyBill(value * 50)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_bill_20"
                  label="20 Bill"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyBill(value * 20)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col
              xs={24}
              style={{ borderBottom: "1px solid #e5e5e5", marginBottom: 10 }}
            >
              <Typography style={{ fontWeight: "bold", fontSize: 18 }}>
                PESO COIN
              </Typography>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_20"
                  label="20 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyCoin(value * 20)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_10"
                  label="10 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settenCoin(value * 10)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_5"
                  label="5 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveCoin(value * 5)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_1"
                  label="1 Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneCoin(value * 1)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_50c"
                  label="50 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiftyCentsCoin(value * 0.5)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_25c"
                  label="25 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settwentyfiveCentsCoin(value * 0.25)}
                  />
                </Form.Item>
              </div>
            </Col>

            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_10c"
                  label="10 Cents"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => settenCentsCoin(value * 0.1)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_5c"
                  label="5 Cents Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setfiveCentsCoin(value * 0.05)}
                  />
                </Form.Item>
              </div>
            </Col>
            <Col xs={8}>
              <div style={{ padding: 2 }}>
                <Form.Item
                  name="g_coin_1c"
                  label="1 Cent Coin"
                  rules={[
                    {
                      required: true,
                      message: "Required",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    max={999999999999}
                    initialvalues={0}
                    size="large"
                    style={{ width: "100%" }}
                    step="1"
                    onChange={(value) => setoneCentCoin(value * 0.01)}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid green",
            }}
          >
            <Typography style={{ fontSize: 22, fontWeight: "bold" }}>
              &#8369;
              {parseFloat(
                parseFloat(oneThousandBill) +
                  parseFloat(fiveHundredBill) +
                  parseFloat(twoHundredBill) +
                  parseFloat(oneHundredBill) +
                  parseFloat(fiftyBill) +
                  parseFloat(twentyBill) +
                  parseFloat(twentyCoin) +
                  parseFloat(tenCoin) +
                  parseFloat(fiveCoin) +
                  parseFloat(oneCoin) +
                  parseFloat(fiftyCentsCoin) +
                  parseFloat(twentyfiveCentsCoin) +
                  parseFloat(tenCentsCoin) +
                  parseFloat(fiveCentsCoin) +
                  parseFloat(oneCentCoin)
              ).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </Typography>
            <Typography style={{ color: "green", fontWeight: "bold" }}>
              Total
            </Typography>
          </div>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update & Confirm Cash Count
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default DialogCashCount;
